<template>
  <v-dialog v-model="value" width="500" persistent>
    <v-card class="w-100 rounded-lg">
      <v-card-title>{{ $t('spedilink.links.deleteTitle') }}</v-card-title>
      <v-card-text>
        <p>
          {{ $t('spedilink.links.deleteMessage') }}
          <strong>{{ link.name }}</strong>?
        </p>
        <p class="error--text mb-0">{{ $t('spedilink.links.deleteWarning') }}</p>
      </v-card-text>
      <v-card-actions class="d-flex justify-end px-4 pb-4">
        <v-btn outlined :disabled="loading" @click="close()">
          {{ $t('common.cancel') }}
        </v-btn>
        <v-btn
          color="error"
          class="ml-2"
          :loading="loading"
          :disabled="loading"
          depressed
          @click="confirmDelete()"
        >
          {{ $t('spedilink.links.delete') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Service from '@/services'

export default {
  name: 'DeleteSpedilinkLinkDialog',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    link: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    async confirmDelete () {
      this.loading = true
      try {
        await Service.delete(`spedilink/SpediLinks/delete/${this.link.id}`)
        await this.$store.dispatch('setSuccessNotification', this.$t('common.confirmOperation'))
        this.$emit('link-deleted')
      } catch (e) {
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
